export function NoteCardSkeleton({ seed = 0 }: { seed?: number }) {
  const widthA = 70 + ((seed * 13) % 25); // 70-94
  const widthB = 55 + ((seed * 29) % 35); // 55-89
  const widthC = 40 + ((seed * 7) % 35); // 40-74

  return (
    <div
      className="jp-panel relative overflow-hidden rounded-sm"
      aria-hidden
    >
      {/* Header strip */}
      <div className="jp-terminal-strip flex items-center justify-between px-3 py-1.5 font-mono text-[0.72rem]">
        <span>◐ DNA SEQUENCING…</span>
        <span className="opacity-70">AWAITING SIGNAL</span>
      </div>

      <div className="p-4">
        {/* Avatar + name rows */}
        <div className="flex items-start gap-3">
          <div className="size-12 rounded-sm bg-jp-amber/10 border border-jp-amber/20 animate-pulse" />
          <div className="flex-1 space-y-2 pt-1">
            <div
              className="h-4 rounded-sm bg-jp-amber/15"
              style={{ width: `${widthA}%` }}
            />
            <div
              className="h-3 rounded-sm bg-jp-amber/10"
              style={{ width: `${widthC}%` }}
            />
          </div>
        </div>

        {/* Divider */}
        <div className="my-3 jp-dna-bar" />

        {/* Content lines */}
        <div className="space-y-2">
          <div
            className="h-3.5 rounded-sm bg-jp-amber/10"
            style={{ width: `${widthB + 10}%` }}
          />
          <div
            className="h-3.5 rounded-sm bg-jp-amber/10"
            style={{ width: `${widthA}%` }}
          />
          <div
            className="h-3.5 rounded-sm bg-jp-amber/10"
            style={{ width: `${widthB}%` }}
          />
        </div>

        {/* DNA sequencing indicator */}
        <div className="mt-4 flex items-center gap-2 font-mono text-[0.65rem] text-jp-amber/60">
          <span>GT-ACGT-GCA</span>
          <div className="flex-1 jp-dna-bar" />
          <span>{(seed * 37) % 100}%</span>
        </div>
      </div>
    </div>
  );
}
